import * as React from 'react';
import { classes, st } from './Ribbon.st.css';
import { RibbonProps, RibbonShape } from './types';
import { Video } from '@wix/wix-ui-icons-common/on-stage';
import { BlogLarge } from '@wix/wix-ui-icons-common/on-stage/system';

/** A ribbon is a visual indicator that helps users quickly locate an item that has an important distinctive attribute within a list of otherwise  similar objects */
export class Ribbon extends React.Component<RibbonProps> {
  static displayName = 'Ribbon';

  render() {
    const { className, children, shape } = this.props;

    return (
      <div
        className={st(
          classes.root,
          { square: shape === RibbonShape.Square },
          className,
        )}
        data-hook={this.props['data-hook']}
      >
        {className === '1' && <Video />}
        {className === '2' && <BlogLarge />}
        {children}
      </div>
    );
  }
}
